import { Logo, PlayIconFilled } from '@mote/assets/icons'
import { Avatar, Block, Text, Tooltip } from '@mote/ui'
import React from 'react'
import styled, { css } from 'styled-components'
import { useMotePlayer } from '../../../shared/contexts/motePlayer.context'
import { moteCardFluidDimensionsAdjuster } from '../fluidSizing'
import { MoteCardRichFloatingDuration } from '../MoteCardRichFloatingDuration'

export const MoteCardIdleState = ({
  duration,
  onInit,
  createdContext,
  createdByName,
  createdByAvatar,
  showLogo
}) => {
  const { isReady, play, theme, playerDimensions } = useMotePlayer()

  function handlePlay() {
    play()
    onInit(false)
  }

  return (
    <Root
      role='button'
      aria-label='Play'
      disabled={!isReady}
      onClick={isReady ? handlePlay : null}
      data-testid='idle-play-button'
    >
      <MoteCreator className='mote-card-creator'>
        <Text
          fontWeight={400}
          fontSize={moteCardFluidDimensionsAdjuster(
            16,
            10,
            playerDimensions?.width
          )}
          lineHeight='100%'
          color={theme?.createdByName}
          data-testid='mote-title-text'
        >
          {createdByName}
        </Text>
        <Text
          fontWeight={500}
          fontSize={moteCardFluidDimensionsAdjuster(
            18,
            12,
            playerDimensions?.width
          )}
          lineHeight='100%'
          color={theme?.niceTitle}
        >
          {createdContext}
        </Text>
      </MoteCreator>

      <AvatarAndPlayIconContainer tabIndex={-1}>
        <Avatar
          tabIndex={-1}
          className='mote-card-avatar'
          size={moteCardFluidDimensionsAdjuster(
            202,
            102,
            playerDimensions?.width
          )}
          fontSize={moteCardFluidDimensionsAdjuster(
            15,
            12,
            playerDimensions?.width
          )}
          text={createdByName}
          url={createdByAvatar}
        />
        <PlayIconContainer aria-hidden={true}>
          <Tooltip content={!isReady ? 'Loading mote ...' : 'Play'}>
            <PlayIconFilled
              width={moteCardFluidDimensionsAdjuster(
                110,
                51,
                playerDimensions?.width
              )}
              height={moteCardFluidDimensionsAdjuster(
                110,
                51,
                playerDimensions?.width
              )}
            />
          </Tooltip>
        </PlayIconContainer>
      </AvatarAndPlayIconContainer>

      <MoteCardRichFloatingDuration type='total' duration={duration} />

      {showLogo && (
        <LogoContainer tabIndex={-1} aria-hidden={true}>
          <Logo
            color={theme?.logo.color}
            style={{
              width: moteCardFluidDimensionsAdjuster(
                92,
                62,
                playerDimensions?.width
              ),
              height: moteCardFluidDimensionsAdjuster(
                32,
                18,
                playerDimensions?.width
              )
            }}
          />
        </LogoContainer>
      )}
    </Root>
  )
}

const Root = styled.div`
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  transition: background 150ms;

  &:hover {
    background: rgba(0, 0, 0, 0.4);
  }

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
    `}
`

const MoteCreator = styled(Block)`
  position: absolute;
  top: 0;
  left: 0;
  padding: 6%;

  & > h1 {
    margin-bottom: 1%;
  }
`

const AvatarAndPlayIconContainer = styled.div`
  position: relative;
  display: grid;
  place-items: center;
  outline: transparent solid 2px !important;
  outline-offset: 2px;
`

const PlayIconContainer = styled.div`
  position: absolute;
  display: grid;
  place-items: center;
  z-index: 2;
  outline: transparent solid 2px !important;
  outline-offset: 2px;
`
const LogoContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 6%;
  outline: transparent solid 2px !important;
  outline-offset: 2px;
`
